<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { getSalesActiveFilterEntries } from '../composables/salesActiveFilterPresenter';

const props = defineProps({
  agents: { type: Array, default: () => [] },
  filters: { type: Object, required: true },
  postSaleStatuses: { type: Array, default: () => [] },
});

const emit = defineEmits(['remove']);
const { t } = useI18n();
const entries = computed(() =>
  getSalesActiveFilterEntries({
    filters: props.filters,
    agents: props.agents,
    postSaleStatuses: props.postSaleStatuses,
    t,
  })
);
</script>

<template>
  <div
    v-show="entries.length"
    class="flex flex-wrap items-center gap-2"
    aria-live="polite"
  >
    <button
      v-for="entry in entries"
      :key="`${entry.key}-${entry.value}`"
      type="button"
      class="inline-flex items-center gap-1 rounded-full border border-lais-border bg-white px-3 py-1 text-xs font-semibold text-lais-text-body hover:border-lais-primary"
      :aria-label="t('SALES.ACTIVE_FILTERS.REMOVE', { label: entry.label })"
      @click="emit('remove', entry)"
    >
      <span>{{ entry.label }}</span>
      <span class="i-lucide-x size-3" aria-hidden="true" />
    </button>
  </div>
</template>
